export function roundFloat (number) {
  return Math.round((number + Number.EPSILON) * 100) / 100
}
